module.exports = __webpack_public_path__ + "static/media/WebSurfer-snapshot-3.6a6990f2.png";


//////////////////
// WEBPACK FOOTER
// ./images/DashMobile/WebSurfer-snapshot-3.png
// module id = 445
// module chunks = 0